/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Subscribe_viewer = {
    readonly id: string;
    readonly userAccounts: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
        readonly subscriber: {
            readonly defaultMethod: {
                readonly last4: string;
            } | null;
            readonly currency: string;
        };
    }> | null;
    readonly " $refType": "Subscribe_viewer";
};
export type Subscribe_viewer$data = Subscribe_viewer;
export type Subscribe_viewer$key = {
    readonly " $data"?: Subscribe_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Subscribe_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Subscribe_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "userAccounts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Subscriber",
          "kind": "LinkedField",
          "name": "subscriber",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaymentMethod",
              "kind": "LinkedField",
              "name": "defaultMethod",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "last4",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
})();
(node as any).hash = '608eb6db1c8e407cc0b8e1440b59c700';
export default node;
